import 'leaflet-easybutton/src/easy-button.js';
import 'leaflet-easybutton/src/easy-button.css';
import { Map as LeafletMap, TileLayer } from 'leaflet';

const ZOOM_INICIAL = 12;
const MAX_ZOOM = 18;

const Map = (mapId, pontoInicial) => {
  const map = new LeafletMap(mapId, {scrollWheelZoom: false, attributionControl: false}).setView(pontoInicial, ZOOM_INICIAL);
  new TileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
    maxZoom: MAX_ZOOM,
    id: 'mapbox.streets',
  }).addTo(map);

  return map;
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/mapa/Map.js